module.exports = __webpack_public_path__ + "img/next.41aaa9c9.svg";